module.exports = __webpack_public_path__ + "static/media/square-black.007b18f5.svg";